// Set the base URL for your backend
const API_URL = process.env.REACT_APP_SERVER_URL;

// Helper function to handle fetch responses
const handleResponse = async (response) => {
    const result = await response.json();

    if (!result.success) {
        const msgs = ['Access denied. No token provided.', 'Access denied.', 'User not found', 'Invalid token.'];
        const tokenMsgs = ['NO_TOKEN', 'INVALID_TOKEN', 'NO_USER_TOKEN'];
        const { message } = result;

        if (tokenMsgs.includes(message)) {
            window.location.href = "/login";
        }

        return {
            success: false,
            error: (message || 'Something went wrong'),
            hideButton: msgs.includes(message) ? false : true
        };
    }

    return { success: true, data: result.data };
};

// =========================
// BSS Clients
// =========================
export const getAllBsClients = async (deleted = false) => {
    try {
        const response = await fetch(`${API_URL}/bss/clients?deleted=${deleted}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS clients', error);
        throw error;
    }
};

export const getBsClientById = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/clients/${id}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS client', error);
        throw error;
    }
};

export const createBsClient = async (data) => {
    try {
        const response = await fetch(`${API_URL}/bss/clients`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error creating BSS client', error);
        throw error;
    }
};

export const updateBsClient = async (id, data) => {
    try {
        const response = await fetch(`${API_URL}/bss/clients/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error updating BSS client', error);
        throw error;
    }
};

export const deleteBsClient = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/clients/${id}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error deleting BSS client', error);
        throw error;
    }
};

export const restoreBsClient = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/clients/restore/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error restoring BSS client', error);
        throw error;
    }
};

// =========================
// BSS Sample Types
// =========================
export const getAllBsSampleTypes = async (deleted = false) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-types?deleted=${deleted}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS sample types', error);
        throw error;
    }
};

export const getBsSampleTypeById = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-types/${id}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS sample type', error);
        throw error;
    }
};

export const createBsSampleType = async (data) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-types`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error creating BSS sample type', error);
        throw error;
    }
};

export const updateBsSampleType = async (id, data) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-types/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error updating BSS sample type', error);
        throw error;
    }
};

export const deleteBsSampleType = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-types/${id}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error deleting BSS sample type', error);
        throw error;
    }
};

export const restoreBsSampleType = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-types/restore/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error restoring BSS sample type', error);
        throw error;
    }
};

// =========================
// BSS Sample Size Charts
// =========================
export const getAllBsSampleSizeCharts = async (deleted = false) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-size-charts?deleted=${deleted}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS sample size charts', error);
        throw error;
    }
};

export const getBsSampleSizeChartById = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-size-charts/${id}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS sample size chart', error);
        throw error;
    }
};

export const createBsSampleSizeChart = async (data) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-size-charts`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error creating BSS sample size chart', error);
        throw error;
    }
};

export const updateBsSampleSizeChart = async (id, data) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-size-charts/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error updating BSS sample size chart', error);
        throw error;
    }
};

export const deleteBsSampleSizeChart = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-size-charts/${id}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error deleting BSS sample size chart', error);
        throw error;
    }
};

export const restoreBsSampleSizeChart = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/sample-size-charts/restore/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error restoring BSS sample size chart', error);
        throw error;
    }
};

// =========================
// BSS Testing Types
// =========================
export const getAllBsTestingTypes = async (deleted = false) => {
    try {
        const response = await fetch(`${API_URL}/bss/testing-types?deleted=${deleted}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS testing types', error);
        throw error;
    }
};

export const getBsTestingTypeById = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/testing-types/${id}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS testing type', error);
        throw error;
    }
};

export const createBsTestingType = async (data) => {
    try {
        const response = await fetch(`${API_URL}/bss/testing-types`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error creating BSS testing type', error);
        throw error;
    }
};

export const updateBsTestingType = async (id, data) => {
    try {
        const response = await fetch(`${API_URL}/bss/testing-types/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error updating BSS testing type', error);
        throw error;
    }
};

export const deleteBsTestingType = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/testing-types/${id}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error deleting BSS testing type', error);
        throw error;
    }
};

export const restoreBsTestingType = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/testing-types/restore/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error restoring BSS testing type', error);
        throw error;
    }
};

// =========================
// BSS COCs
// =========================
export const getAllBsCocs = async (deleted = false) => {
    try {
        const response = await fetch(`${API_URL}/bss/cocs?deleted=${deleted}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS COCs', error);
        throw error;
    }
};

export const getBsCocById = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/cocs/${id}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error fetching BSS COC', error);
        throw error;
    }
};

export const createBsCoc = async (data) => {
    try {
        const response = await fetch(`${API_URL}/bss/cocs`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error creating BSS COC', error);
        throw error;
    }
};

export const updateBsCoc = async (id, data) => {
    try {
        const response = await fetch(`${API_URL}/bss/cocs/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error updating BSS COC', error);
        throw error;
    }
};

export const deleteBsCoc = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/cocs/${id}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error deleting BSS COC', error);
        throw error;
    }
};

export const restoreBsCoc = async (id) => {
    try {
        const response = await fetch(`${API_URL}/bss/cocs/restore/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return handleResponse(response);
    } catch (error) {
        console.error('Error restoring BSS COC', error);
        throw error;
    }
};